import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { accountViewGuard } from '@shared/guards/account-view.guard';
import { loggedIn, loggedOut, shellAccessGuard } from '@stillmandigital/common';
import { environment } from 'environments/environment';
import { changePasswordGuard } from './auth/change-password.guard';
import { ChangePasswordPageComponent } from './auth/components/change-password-page/change-password-page.component';
import { LoginPageComponent } from './auth/components/login-page/login-page.component';
import { PageNotFoundComponent } from './shell/components/page-not-found/page-not-found.component';
import { ShellComponent } from './shell/components/shell/shell.component';

const routes: Routes = [
  {
    path: '',
    component: ShellComponent,
    canActivate: [loggedIn, shellAccessGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },
      {
        path: 'dashboard',
        canActivate: [accountViewGuard('dashboard')],
        loadChildren: () =>
          import('./dashboard/dashboard.module').then(module => module.DashboardModule),
      },
      ...(environment.coinlionEnabled
        ? [
            {
              path: 'strategies',
              canActivate: [accountViewGuard('strategies')],
              loadComponent: () =>
                import('./strategies/components/strategies/strategies.component').then(
                  module => module.StrategiesComponent,
                ),
            },
          ]
        : []),
    ],
  },
  {
    path: 'login',
    canActivate: [loggedOut],
    component: LoginPageComponent,
  },
  {
    path: 'change-password',
    canActivate: [loggedIn, changePasswordGuard],
    component: ChangePasswordPageComponent,
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
